import { Component, OnInit } from '@angular/core';
import { DownloadSectionComponent } from '../../components/download-section/download-section.component';
import { PeriodTrackerService } from '../../services/period-tracker.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-period-tracker',
  standalone: true,
  imports: [DownloadSectionComponent, CommonModule],
  templateUrl: './period-tracker.component.html',
  styleUrl: './period-tracker.component.css'
})
export class PeriodTrackerComponent implements OnInit {
  periodTrackerContent: any;

  constructor(private periodTrackerService: PeriodTrackerService) {}

  ngOnInit(): void {
    this.periodTrackerService.getPeriodTrackerContent().subscribe(data => {
      this.periodTrackerContent = data[0];
    });
  }
}
